import React, { Fragment } from 'react'
import styles from './FeatureDetails.scss'
import { formatDistance } from 'lib/units'
import { photoMedium, photoMilli } from 'lib/urlHelpers'
import { showGallery } from 'features/gallery/showGallery'
import { clampStringWords, capitalize } from 'lib/utils'
import _ from 'lodash'

// const HIGHLIGHT_PHOTOS = [
//   3182669,
//   3184802,
//   3184803,
//   3184807,
//   3184809,
//   3184811
// ]

const urlForFeature = (domain, feature) => {
  switch (feature.type) {
    case 'route':
    case 'trip':
      return `${domain}/${feature.type}s/${feature.id}`
    default:
      return false
  }
}

export class FeatureDetails extends React.PureComponent {
  onClickWrap = (e) => {
    const { onRequestClose } = this.props
    this._wrap === e.target && onRequestClose()
  }

  render () {
    const { asset, feature, urls, hideFeatureLink, metricUnits, showUnitConversion, onRequestClose, noLinks } = this.props
    const assetIndex = capitalize(feature.type)
    const customURL = asset.url ||
      (urls &&
      urls[assetIndex] &&
      urls[assetIndex][feature.id])
    const domain = window.location.host === 'rwgps-embeds.com'
      ? '//ridewithgps.com'
      : ''
    // terrible hack to demo photos for POI
    // if (!asset.highlighted_photo_id) {
    //   asset.highlighted_photo_id = HIGHLIGHT_PHOTOS[asset.id % HIGHLIGHT_PHOTOS.length]
    // }
    const target = (feature.type === 'route' && customURL)
      ? '_top'
      : '_blank'

    const assetURL = !hideFeatureLink && (customURL || urlForFeature(domain, feature))

    const filterAssetLinkProps = props => _.omit(props, 'hideOnBlankURL')
    const AssetLink = assetURL
      ? (props) => <a href={assetURL} target={target} {...filterAssetLinkProps(props)} />
      : (props) => props.hideOnBlankURL ? <span /> : <div style={{ display: 'inline-block' }} {...filterAssetLinkProps(props)} />
    const HeaderPhoto = () => <img src={photoMedium(asset.highlighted_photo_id)} />

    return (
      <div className={styles.wrap} onClick={this.onClickWrap} ref={r => { this._wrap = r }}>
        <div className={styles.FeatureDetails}>
          {!!asset.highlighted_photo_id && <div className={styles.photoWrap}>
            {noLinks && <HeaderPhoto />}
            {!noLinks && <AssetLink><HeaderPhoto /></AssetLink>}
          </div>}
          <div className={styles.textContent}>
            {(feature.type === 'trip' || feature.type === 'route') && <TripRouteDetails
              AssetLink={AssetLink}
              noLinks={noLinks}
              asset={asset}
              feature={feature}
              metricUnits={metricUnits}
              showUnitConversion={showUnitConversion} />}
            {feature.type === 'poi' && <POIDetails
              AssetLink={AssetLink}
              asset={asset}
              feature={feature} />}
          </div>
          <div className={styles.closeButton} onClick={onRequestClose}>close</div>
        </div>
      </div>
    )
  }
}

const TripRouteDetails = ({ AssetLink, noLinks, asset, feature, metricUnits, showUnitConversion }) => {
  const distanceString = (distance, { metricUnits, showUnitConversion }) => {
    const primary = formatDistance(distance, { metricUnits }).toString({ short: true })
    const secondary = formatDistance(distance, { metricUnits: !metricUnits }).toString({ short: true })
    return showUnitConversion
      ? `${primary} (${secondary})`
      : primary
  }

  const eleString = (ele, { metricUnits, showUnitConversion }) => {
    const primary = formatDistance(ele, { smallUnits: true, metricUnits }).toString({ short: true })
    const secondary = formatDistance(ele, { smallUnits: true, metricUnits: !metricUnits }).toString({ short: true })
    return showUnitConversion
      ? `${primary} (${secondary})`
      : primary
  }

  const showPrintPdf = (feature.type === 'route' && asset.official_map_url)

  return (
    <div>
      <h3>
        {noLinks && <Fragment>{asset.name}</Fragment>}
        {!noLinks && <AssetLink>{asset.name}</AssetLink>}
      </h3>
      <p className={styles.small}>
        <span className={styles.metric}>
          {distanceString(asset.distance, { metricUnits, showUnitConversion })}
        </span>
        <span className={styles.metric}>
          +{eleString(asset.elevation_gain, { metricUnits, showUnitConversion })}
        </span>
      </p>
      <p>{clampStringWords(asset.description || '', 140)}</p>
      {!noLinks && <p className={styles.details}>
        <AssetLink hideOnBlankURL>View {capitalize(feature.type)}</AssetLink>
        {showPrintPdf && <a href={asset.official_map_url} target='_blank'>Print PDF</a>}
      </p>}
    </div>
  )
}

const POIDetails = ({ AssetLink, asset, feature }) => {
  const photos = asset.photoIds && asset.photoIds.map(pid => ({ id: pid }))
  return (
    <div>
      <h3><AssetLink>{asset.n}</AssetLink></h3>
      <p>{clampStringWords(asset.d, 140)}</p>
      {asset.url && <p className={styles.details}>
        <a target='_blank' href={asset.url}>{asset.url}</a>
      </p>}
      {asset.photoIds && <div className={styles.detailsPhotos}>
        {asset.photoIds.map(pid => <img
          key={pid}
          src={photoMilli(pid)}
          onClick={() => showGallery({ photos: photos, activePhotoId: pid })}
        />)}
      </div>}
    </div>
  )
}
